<template>
  <div class="cp-frame">
    <slot></slot>
    <!-- <div class="header"></div>
    <div class="center">
      <slot></slot>
    </div>
    <div class="frame-footer"></div> -->
  </div>
</template>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  .cp-frame
    width 6.91rem
    height auto;
    min-height 2.64rem
    background-image url("./images/header.png"), url("./images/center.png"), url("./images/footer.png");
    background-position: top left, center left, bottom left;
    background-size: 6.91rem 1.06rem, 6.91rem calc(100% - 2.12rem), 6.91rem 1.06rem;
    background-repeat: no-repeat, no-repeat, no-repeat;
</style>
<script>
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: true
    }
  },
  mounted() {

  },
  methods: {
    handleClose(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit('close')
      // store.commit(types.HIDE_MODAL);
    }
  }
}
</script>

